import { AdvancedSearch } from './advanced-search';
import { BatchesArchived } from './batches-archived';
import { BatchesOpen } from './batches-open';
import { BatchesProcessed } from './batches-processed';
import { Batches } from './batches';
import { Delivered } from './delivered';
import { DeliveryException } from './delivery-exception';
import { Voided } from './voided';
import { EndOfDayCategory } from './end-of-day-category';
import { EndOfDay } from './end-of-day';
import { ContainerShipments } from './container-shipments';
import { InTransit } from './in-transit';
import { Fulfillments } from './fulfillments';
import { FulfillmentsRecent } from './fulfillments-recent';
import { FulfillmentsPending } from './fulfillments-pending';
import { FulfillmentsInTransit } from './fulfillments-in-transit';
import { FulfillmentsDelivered } from './fulfillments-delivered';
import { FulfillmentsDeliveryException } from './fulfillments-delivery-exception';
import { FulfillmentsCancelled } from './fulfillments-cancelled';
import { FulfillmentsReturns } from './fulfillments-returns';
import { ScheduledPickups } from './scheduled-pickups';
import { Pickup } from './pickup';
import { Recent } from './recent';
import { Returns } from './returns';
import { Shipped } from './shipped';
import { RefundAssist } from './refund-assist';
import { BatchesAdvancedSearch } from './batches-advanced-search';
import { ReturnsAdvancedSearch } from './returns-advanced-search';
import { ShipmentsPickup } from './shipments-pickup';
import { FulfillmentsAdvancedSearch } from './fulfillments-advanced-search';
import { pendingCustomsDocumentsView as PendingCustomsDocuments } from './pending-customs-documents';

export const shippingGridViews = [
  AdvancedSearch,
  BatchesAdvancedSearch,
  ReturnsAdvancedSearch,
  BatchesArchived,
  BatchesOpen,
  BatchesProcessed,
  Batches,
  Delivered,
  DeliveryException,
  Voided,
  EndOfDayCategory,
  EndOfDay,
  ContainerShipments,
  InTransit,
  ScheduledPickups,
  ShipmentsPickup,
  Pickup,
  Recent,
  Returns,
  Shipped,
  Fulfillments,
  FulfillmentsRecent,
  FulfillmentsPending,
  FulfillmentsInTransit,
  FulfillmentsDelivered,
  FulfillmentsDeliveryException,
  FulfillmentsCancelled,
  FulfillmentsReturns,
  FulfillmentsAdvancedSearch,
  RefundAssist,
  PendingCustomsDocuments,
];
